import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getDynamicTariffs } from 'app/entities/dynamic-tariff/dynamic-tariff.reducer';
import { getEntities as getProducts } from 'app/entities/product/product.reducer';
import { createEntity, getEntity, reset, updateEntity } from './hourly-product-usage.reducer';

export const HourlyProductUsageUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const dynamicTariffs = useAppSelector(state => state.dynamicTariff.entities);
  const products = useAppSelector(state => state.product.entities);
  const hourlyProductUsageEntity = useAppSelector(state => state.hourlyProductUsage.entity);
  const loading = useAppSelector(state => state.hourlyProductUsage.loading);
  const updating = useAppSelector(state => state.hourlyProductUsage.updating);
  const updateSuccess = useAppSelector(state => state.hourlyProductUsage.updateSuccess);

  const handleClose = () => {
    navigate('/hourly-product-usage');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getDynamicTariffs({}));
    dispatch(getProducts({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.id !== undefined && typeof values.id !== 'number') {
      values.id = Number(values.id);
    }
    values.from = convertDateTimeToServer(values.from);
    values.util = convertDateTimeToServer(values.util);
    if (values.hourlyUsage !== undefined && typeof values.hourlyUsage !== 'number') {
      values.hourlyUsage = Number(values.hourlyUsage);
    }

    const entity = {
      ...hourlyProductUsageEntity,
      ...values,
      tariff: dynamicTariffs.find(it => it.id.toString() === values.tariff?.toString()),
      product: products.find(it => it.id.toString() === values.product?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {
          from: displayDefaultDateTime(),
          util: displayDefaultDateTime(),
        }
      : {
          ...hourlyProductUsageEntity,
          from: convertDateTimeFromServer(hourlyProductUsageEntity.from),
          util: convertDateTimeFromServer(hourlyProductUsageEntity.util),
          tariff: hourlyProductUsageEntity?.tariff?.id,
          product: hourlyProductUsageEntity?.product?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="crawlerBackendApp.hourlyProductUsage.home.createOrEditLabel"
            data-cy="HourlyProductUsageCreateUpdateHeading"
          >
            <Translate contentKey="crawlerBackendApp.hourlyProductUsage.home.createOrEditLabel">
              Create or edit a HourlyProductUsage
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="hourly-product-usage-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('crawlerBackendApp.hourlyProductUsage.from')}
                id="hourly-product-usage-from"
                name="from"
                data-cy="from"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.hourlyProductUsage.util')}
                id="hourly-product-usage-util"
                name="util"
                data-cy="util"
                type="datetime-local"
                placeholder="YYYY-MM-DD HH:mm"
              />
              <ValidatedField
                label={translate('crawlerBackendApp.hourlyProductUsage.hourlyUsage')}
                id="hourly-product-usage-hourlyUsage"
                name="hourlyUsage"
                data-cy="hourlyUsage"
                type="text"
              />
              <ValidatedField
                id="hourly-product-usage-tariff"
                name="tariff"
                data-cy="tariff"
                label={translate('crawlerBackendApp.hourlyProductUsage.tariff')}
                type="select"
              >
                <option value="" key="0" />
                {dynamicTariffs
                  ? dynamicTariffs.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="hourly-product-usage-product"
                name="product"
                data-cy="product"
                label={translate('crawlerBackendApp.hourlyProductUsage.product')}
                type="select"
              >
                <option value="" key="0" />
                {products
                  ? products.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/hourly-product-usage"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button
                color="primary"
                id="save-entity"
                data-cy="entityCreateSaveButton"
                type="submit"
                disabled={updating}
              >
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default HourlyProductUsageUpdate;
